import { AUTHORIZATION_HEADER } from '../../../../../src/authorization';
import { send } from '../../../../../src/network';
import { type PromoV1 } from '../../../../../src/types/PromoV1';

export { type PromoV1 };

export interface PromoCodeType {
  code: string;
  code_effect: string;
  factory_effect: {
    promos: PromoV1[];
    free_item_effect: string;
    discount_effect: string;
    effect_str: string;
    effect_base: string;
  };
  type: string;
  value: string;
  is_reactivation: boolean;
  is_cancel_winback: boolean;
}

type PromoQueryParams = {
  [use_case: string]: string;
};

export async function getV2PromoCode(
  promoCode: string,
  queryParams?: PromoQueryParams
) {
  const query = new URLSearchParams(queryParams || {});

  return send<PromoCodeType>({
    path: `/api/v2/promo/${promoCode}`,
    method: 'GET',
    query,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}

export interface InvalidPromoCode {
  valid: false;
  message: string;
}
